// extracted by mini-css-extract-plugin
export default {"commentBox":"index_commentBox_VEqV3"};